import { Controller, useFormContext } from 'react-hook-form'

import { Switch } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'roundTrip'
type Props = WithFieldPermissionsProps

const RoundTripField = (props: Props) => {
  const { control, setValue, watch } = useFormContext()
  const { isFieldReadOnly } = props
  const mileage = watch('mileage')

  const handleMileageRoundTripChange = (value: boolean) => {
    if (value) {
      setValue('mileage', mileage * 2)
    } else {
      setValue('mileage', mileage / 2)
    }
  }
  return (
    <Controller
      control={control}
      name={FIELD_NAME}
      render={({ field }) => (
        <Switch
          title={i18n.t('expenses_v2.forms.fields.round_trip.label')}
          checked={field.value}
          onCheckedChange={(value) => {
            field.onChange(value)
            if (mileage) {
              handleMileageRoundTripChange(value)
            }
          }}
          disabled={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withFieldPermissions(RoundTripField, FIELD_NAME)
